// extracted by mini-css-extract-plugin
export var details = "ExhibitionTimeline-module--details--f9d0e";
export var dragIndicator = "ExhibitionTimeline-module--dragIndicator--b1567";
export var exhibitiontimeline = "ExhibitionTimeline-module--exhibitiontimeline--5cd5e";
export var header = "ExhibitionTimeline-module--header--7dc40";